// import crypto from "crypto";
import * as CryptoJS from "crypto-js";

type SaltContextType = "general" | "auth" | "otp" | "payment" | "order";

// const ALGORITHM = "aes-256-cbc";

function getSalt(type?: SaltContextType) {
  switch (type) {
    case "auth":
      return process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
        ? process.env.NEXT_PUBLIC_SECRET_KEY_ACCOUNT ??
            process.env.NEXT_PUBLIC_SECRET_KEY
        : process.env.NEXT_PUBLIC_SECRET_KEY;
    case "otp":
      return process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
        ? process.env.NEXT_PUBLIC_SECRET_KEY_OTP_VERIFY_PIN ??
            process.env.NEXT_PUBLIC_SECRET_KEY
        : process.env.NEXT_PUBLIC_SECRET_KEY;
    case "payment":
      return process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
        ? process.env.NEXT_PUBLIC_SECRET_KEY_PAYMENT ??
            process.env.NEXT_PUBLIC_SECRET_KEY
        : process.env.NEXT_PUBLIC_SECRET_KEY;
    case "order":
      return process.env.NEXT_PUBLIC_ENVIRONMENT === "production"
        ? process.env.NEXT_PUBLIC_SECRET_KEY_ORDER ??
            process.env.NEXT_PUBLIC_SECRET_KEY
        : process.env.NEXT_PUBLIC_SECRET_KEY;
    default:
      return process.env.NEXT_PUBLIC_SECRET_KEY;
  }
}

export function encryptDataNetwork(value: any, type?: SaltContextType): string {
  const text = JSON.stringify(value);
  const key: string = getSalt(type) ?? "";
  const encrypted = CryptoJS.AES.encrypt(text, key);
  return encrypted.toString();
}

export function decryptDataNetwork(plaintext?: string, type?: SaltContextType) {
  if (plaintext) {
    const key: string = getSalt(type) ?? "";
    const decrypted = CryptoJS.AES.decrypt(plaintext, key);
    const decrypted_result = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted_result);
  }
  return "";
}
